import { getUserPermissions, getUserRoleCodes } from "./permissions";

// Called only with the existing refresh response: no fetch and no UI loading state.
export function applyAuthorizationSnapshot(current, snapshot) {
  if (!current || !snapshot) return current;
  const { roles, permissions, roleDetails } = snapshot;
  if (
    !Array.isArray(roles) ||
    !Array.isArray(permissions) ||
    ![...roles, ...permissions].every((value) => typeof value === "string")
  )
    return current;
  const equal = (left, right) =>
    JSON.stringify([...left].sort()) === JSON.stringify([...right].sort());
  if (
    equal(getUserRoleCodes(current), roles) &&
    equal(getUserPermissions(current), permissions)
  )
    return current;
  // Replace nested role permissions too; retaining old nested grants could make
  // the UI accidentally show a permission that has just been revoked.
  return {
    ...current,
    roles: Array.isArray(roleDetails) ? roleDetails : roles,
    permissions,
  };
}
